// SideDrawer — MD3 NavigationDrawer (modal) для mobile (<600px).
// Открывается по бургер-кнопке в TopAppBar. Содержит те же nav items что и NavRail.
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Box, Divider, Typography } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ContactsIcon from '@mui/icons-material/Contacts';
import BusinessIcon from '@mui/icons-material/Business';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import EventIcon from '@mui/icons-material/Event';
import { Link as RouterLink, useLocation } from 'react-router-dom';

interface SideDrawerProps {
  open: boolean;
  onClose: () => void;
}

interface NavItem {
  label: string;
  path: string;
  icon: JSX.Element;
}

const navItems: NavItem[] = [
  { label: 'Дашборд', path: '/dashboard', icon: <DashboardIcon /> },
  { label: 'Задачи', path: '/tasks', icon: <AssignmentIcon /> },
  { label: 'Сделки', path: '/crm/deals', icon: <TrendingUpIcon /> },
  { label: 'Контакты', path: '/crm/contacts', icon: <ContactsIcon /> },
  { label: 'Компании', path: '/crm/companies', icon: <BusinessIcon /> },
  // V12 U-34-E: лиды — зеркально NavRail (Tech-Story §3.7 «SideDrawer — зеркально»).
  { label: 'Лиды', path: '/crm/leads', icon: <PersonSearchIcon /> },
  // V12 U-35-C: «Платежи» — зеркально NavRail (после Лиды, перед Календарь).
  { label: 'Платежи', path: '/payments', icon: <ReceiptLongIcon /> },
  { label: 'Календарь', path: '/calendar', icon: <EventIcon /> },
];

export function SideDrawer({ open, onClose }: SideDrawerProps): JSX.Element {
  const location = useLocation();

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      sx={{
        display: { xs: 'block', sm: 'none' },
      }}
    >
      <Box sx={{ width: 280 }} role="presentation">
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
            Упряжка
          </Typography>
        </Box>
        <Divider />
        <List>
          {navItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            return (
              <ListItem key={item.path} disablePadding>
                <ListItemButton
                  component={RouterLink}
                  to={item.path}
                  selected={isActive}
                  onClick={onClose}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Drawer>
  );
}
